import React from "react";
import styled from "styled-components";

import useSetPreset from "../../hooks/useSetPreset";

import PresetIcon from "../atoms/PresetIcon";

import { presets } from "../../utils/presets";

const Holder = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(6, 1fr);
  gap: 1rem;
`;

function PresetPicker() {
  const { setPreset } = useSetPreset();

  return (
    <Holder>
      {presets.map((preset, index) => {
        return (
          <button key={index} onClick={() => setPreset(preset)}>
            <PresetIcon preset={preset} />
          </button>
        );
      })}
    </Holder>
  );
}

export default PresetPicker;
